import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'LANGUAGE_UPDATE',
    smsDelete : 'LANGUAGE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        language: [],

        submitSuccess: false,
        languageLoading: false,
        languageError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_LANGUAGE(state, language) {
            state.language = language;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        LANGUAGE_LOADING (state, loading) {
            state.languageLoading = loading;
        },

        LANGUAGE_ERROR (state, hasError) {
            state.languageError = hasError;
        }
    },

    actions: {
        async addLanguage ({commit, dispatch}, payload) {
            commit('LANGUAGE_LOADING', true);
            commit('LANGUAGE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_language, payload.language, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLanguage')
                return response

            } catch (e) {
                commit('LANGUAGE_ERROR', true);
            } finally {
                commit('LANGUAGE_LOADING', false);
            }
        },

        async fetchLanguage ({ commit }) {
            commit('LANGUAGE_LOADING', true);
            commit('LANGUAGE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.language_list, config);
                let response = result.data
                commit('SET_LANGUAGE', response.data);

            } catch(error) {
                commit('LANGUAGE_ERROR', true);
            } finally {
                commit('LANGUAGE_LOADING', false);
            }
        },

        async updateLanguage ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_language + payload.id, payload.language, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLanguage')
                return response

            } catch (e) {
                commit('LANGUAGE_ERROR', true);
            } finally {
                commit('LANGUAGE_LOADING', false);
            }
        },
        
        async deleteLanguage({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.language_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchLanguage')
            return response
        }
    },

    getters: {}
}
